import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { Session, User } from '@supabase/supabase-js';

import { auth } from '@/lib/auth';




interface AuthState {

  session: Session | null;

  user: User | null;

  loading: boolean;

  error: string | null;

}




const initialState: AuthState = {

  session: null,

  user: null,

  loading: true,

  error: null,

};




export const getSession = createAsyncThunk(

  'auth/getSession',

  async () => {

    const { data: { session }, error } = await auth.getSession();

    if (error) throw error;

    return session;

  }

);




export const signOut = createAsyncThunk(

  'auth/signOut',

  async () => {

    const { error } = await auth.signOut();

    if (error) throw error;

  }

);




export const getUserInfo = createAsyncThunk(

  'auth/getUserInfo',

  async () => {

    const response = await fetch('/.netlify/functions/getUserInfo', {

      headers: {

        'Authorization': `Bearer ${(await auth.getSession()).data.session?.access_token}`,

      },

    });




    if (!response.ok) {

      throw new Error('Failed to fetch user info');

    }




    return response.json();

  }

);




const authSlice = createSlice({

  name: 'auth',

  initialState,

  reducers: {

    setAuthState: (state, action: PayloadAction<{ session: Session | null; user: User | null }>) => {

      state.session = action.payload.session;

      state.user = action.payload.user;

      state.loading = false;

    },

    setLoading: (state, action: PayloadAction<boolean>) => {

      state.loading = action.payload;

    },

    clearError: (state) => {

      state.error = null;

    },

  },

  extraReducers: (builder) => {

    builder

      .addCase(getSession.pending, (state) => {

        state.loading = true;

        state.error = null;

      })

      .addCase(getSession.fulfilled, (state, action) => {

        state.session = action.payload;

        state.user = action.payload?.user ?? null;

        state.loading = false;

      })

      .addCase(getSession.rejected, (state, action) => {

        state.loading = false;

        state.error = action.error.message ?? 'Failed to get session';

      })

      .addCase(signOut.fulfilled, (state) => {

        state.session = null;

        state.user = null;

        state.loading = false;

      })

      .addCase(signOut.rejected, (state, action) => {

        state.error = action.error.message ?? 'Failed to sign out';

      })

      .addCase(getUserInfo.fulfilled, (state, action) => {

        // Update user info from the API

        if (action.payload.user) {

          state.user = { ...state.user, ...action.payload.user };

        }

      })

      .addCase(getUserInfo.rejected, (state, action) => {

        state.error = action.error.message ?? 'Failed to get user info';

      });

  },

});




export const { setAuthState, setLoading, clearError } = authSlice.actions;

export default authSlice.reducer;